module.exports = __webpack_public_path__ + "img/dice-4.540131e1.svg";